import _extends from "@babel/runtime/helpers/extends";
import React, { useCallback } from 'react';
import { Box } from '@wix/design-system';
import { useHistory } from 'react-router-dom';
import { BusinessNamesSectionV2 } from '../../../Components/BusinessNames';
import { BngResultsHeaderV2 } from '../../../Components/Headers';
import { RecommendationsError } from '../../../Components/Recommendations';
import { useIsMobile } from '../../../hooks/useIsMobile';
import pageStyles from '../../anonymousResultsPage.scss';
import { BngDomainSuggestionsSectionV2 } from './Components/BngDomainSuggestionsSectionV2';
import BngPageLoadError from './Components/BngPageLoadError';
import { BngResultsPageShell, DESKTOP_STICKY_SEARCH_TOP_GAP } from './Components/BngResultsPageShell';
import { useBusinessNamesBi } from './hooks/useBusinessNamesBi';
import { useBngResults } from './hooks/useBngResults';
import { useUrlQueryStoreSync } from './hooks/useUrlQueryStoreSync';
import { useSearchField } from './hooks/useSearchField';
import { useScrollToDomainsHeading } from './hooks/useScrollToDomainsHeading';
import { syncQueryToStore } from './utils/syncQueryToStore';
export const BngResultsPageContentV2 = _ref => {
  let _ref$showCartHeader = _ref.showCartHeader,
    showCartHeader = _ref$showCartHeader === void 0 ? false : _ref$showCartHeader;
  const isMobile = useIsMobile();
  const queryFromUrl = useUrlQueryStoreSync();
  const _useBngResults = useBngResults({
      queryFromUrl
    }),
    hasBusinessNamesError = _useBngResults.hasBusinessNamesError,
    isBusinessNamesReady = _useBngResults.isBusinessNamesReady,
    pageLoadErrorMessage = _useBngResults.pageLoadErrorMessage,
    retryBusinessNames = _useBngResults.retryBusinessNames,
    taxesNotIncluded = _useBngResults.taxesNotIncluded,
    domainSuggestionsProps = _useBngResults.domainSuggestionsProps;
  const _useBusinessNamesBi = useBusinessNamesBi(queryFromUrl),
    onNamesShown = _useBusinessNamesBi.onNamesShown;
  const searchField = useSearchField({
    queryFromUrl
  });
  const history = useHistory();
  const _useScrollToDomainsHe = useScrollToDomainsHeading(),
    stickyHeaderRef = _useScrollToDomainsHe.stickyHeaderRef,
    domainsHeadingRef = _useScrollToDomainsHe.domainsHeadingRef,
    scrollToDomainsHeading = _useScrollToDomainsHe.scrollToDomainsHeading;
  const handleUserSelectedName = useCallback(() => {
    if (isMobile) {
      scrollToDomainsHeading();
    }
  }, [isMobile, scrollToDomainsHeading]);
  if (pageLoadErrorMessage) {
    return /*#__PURE__*/React.createElement(BngPageLoadError, {
      onRetry: retryBusinessNames,
      message: pageLoadErrorMessage
    });
  }
  const sectionPaddingSide = isMobile ? 'SP4' : undefined;
  return /*#__PURE__*/React.createElement(BngResultsPageShell, {
    layout: {
      className: pageStyles.v2Layout,
      pagePaddingSides: isMobile ? '0' : '48px',
      pagePaddingTop: isMobile || showCartHeader ? '0' : 'SP5',
      sectionPaddingSide,
      stickyBarPaddingTop: isMobile ? 'SP5' : DESKTOP_STICKY_SEARCH_TOP_GAP,
      stickyBarPaddingBottom: 'SP2',
      headerPaddingBottom: isMobile ? 'SP2' : undefined
    },
    header: /*#__PURE__*/React.createElement(BngResultsHeaderV2, {
      onBackClick: history.goBack
    }),
    searchField: {
      ...searchField,
      outline: 'light'
    },
    stickyHeaderRef: stickyHeaderRef
  }, !hasBusinessNamesError && !queryFromUrl && /*#__PURE__*/React.createElement(RecommendationsError, {
    error: "NoRecommendations",
    onRetry: domainSuggestionsProps.onRetry,
    type: "anonymous",
    gridArea: "content",
    className: pageStyles.centeredContent,
    paddingLeft: sectionPaddingSide,
    paddingRight: sectionPaddingSide
  }), queryFromUrl && /*#__PURE__*/React.createElement(Box, {
    gridArea: "content",
    className: pageStyles.centeredContent,
    direction: isMobile ? 'vertical' : 'horizontal',
    gap: isMobile ? 'SP7' : 'SP6',
    verticalAlign: "top",
    paddingTop: isMobile ? 'SP3' : 'SP2'
  }, /*#__PURE__*/React.createElement(Box, {
    width: isMobile ? '100%' : '300px',
    flexShrink: 0
  }, /*#__PURE__*/React.createElement(BusinessNamesSectionV2, {
    query: queryFromUrl,
    onSelectedNameChange: syncQueryToStore,
    onUserSelectedName: handleUserSelectedName,
    onNamesShown: onNamesShown
  })), !hasBusinessNamesError && /*#__PURE__*/React.createElement(Box, {
    flexGrow: 1,
    minWidth: "0px",
    width: isMobile ? '100%' : undefined,
    paddingLeft: sectionPaddingSide,
    paddingRight: sectionPaddingSide,
    boxSizing: "border-box"
  }, /*#__PURE__*/React.createElement(BngDomainSuggestionsSectionV2, _extends({}, domainSuggestionsProps, {
    headingRef: domainsHeadingRef,
    isBusinessNamesReady: isBusinessNamesReady,
    taxesNotIncluded: taxesNotIncluded
  })))));
};
//# sourceMappingURL=BngResultsPageContentV2.js.map